// extracted by mini-css-extract-plugin
export var readonly = "_f5-1";
export var star = "_f5-0";